module.exports = __webpack_public_path__ + "static/media/btn_sm.f547ceed.png";